import { render } from "./TravelAdvice.vue?vue&type=template&id=c3f6a888&scoped=true"
import script from "./TravelAdvice.vue?vue&type=script&lang=js"
export * from "./TravelAdvice.vue?vue&type=script&lang=js"

import "./TravelAdvice.vue?vue&type=style&index=0&id=c3f6a888&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c3f6a888"]])

export default __exports__